import Vue from 'vue'
import axios from 'axios';

import PUBLIC from '../config/public'
import CONFIG from '../config/tipsConfig'

//store
import store from "@/components/store/index.js";

let localStore = {};

let winW = document.documentElement.clientWidth,
    winH = document.documentElement.clientHeight;

let env = process.env.NODE_ENV == 'development' ? 'dev' : 'prod';

document.getElementsByTagName('body')[0].style.position='relative';

Vue.directive('tips',{
    //指令与元素被绑定时
    bind (ele,binding){
        ele.value = binding.value;
        const handler = (e) => {
            binding.value(e)
        }        
    },
    //指令所在元素被插入页面时
    inserted (ele,binding){
        ele.value = binding.value;
        if(ele.value == '1')return;

        if(PUBLIC.device == 'pc'){
            pcBindHanlder(ele , binding.value);
        }
        else{
            mobileBindHanlder(ele , binding.value);
        }

    },
    //指令所在面板被重新解析时
    update (ele,binding,vNode){
        //destory(ele);
        //ele.removeEventListener('click', ele.handler)
        //console.log('new' , ele);
        if(ele.value == binding.value)return;
        ele.value = binding.value;
        if(PUBLIC.device == 'pc'){
            ele.onmouseenter= false;
            ele.onmousemove= false;
            ele.onmouseleave= false;

            pcBindHanlder(ele , binding.value);
        }
        else{
            ele.onclick = false;
            mobileBindHanlder(ele , binding.value);
        }             
    },
    componentUpdated: function(ele, binding) {
        //TODO
        ele.value = binding.value;
    }    
});

function fuckTipsTxtFormat(text){
    if(!text)return '详细内容见游戏';

    return text.replace(
        /\|r\|n\|cff99d3ff\s\|r\d{0,2}\.{0,1}\|pUI.*?\|e\|(\w{9})/gi,
        '|r|n|$1'
    )
    .replace(
        /已拥有|可激活|\|n\|Cffff0000仍需3个该封灵玉换装用于升级封将台技能\|r\|n/,
        ''
    )
    .replace(/\(当前好感.*?\)/, '')
    .replace(/镶嵌位置：.*?\|n/, '')
    .replace(/\|n\|cFFFFAA00镶嵌后获得神兵值.*?\|r/, '')
    .replace(/\|r\|pUI(.*?)\|e\|\S*/g, '')
    .replace(/\|n/g, '<br/>')
    .replace(/\|cff(\w{6})/gi, '<span style="color:#$1">')
    .replace(/\|p\|\w16(.*?\.mst\|e)/gi, '')
    .replace(/\|r/g, '</span>');
    
}

async function getContext(id , type){
    let pc_css = PUBLIC.device == 'pc' && type == 'text' ? 'style="width : 300px;padding : 5px;"' : '';
    if(!localStore[id] && type != 'img'){
        var tips_contxt = '';
        await axios({
            method: 'get',
            url: CONFIG.ajax_url,
            params:{
                id : id,
                '_': +new Date(),
            },
            withCredentials: true,
            responseType: 'json',
            headers: {},
        })
        .then(res => {
            //console.log('res' , res)
                if(res.data.code == 1){
                    //success
                    //console.log(id)
                    localStore[id] = res.data.data[0];
                    tips_contxt = getHtml(id , type);
                }
            },rej => {
                //sick code
                if(rej.data.code == 1){
                    //success
                    localStore[id] = rej.data.data[0];
                    tips_contxt = getHtml(id , type);
                }
                                      
            })
        .catch(err=>{
            console.error(err);
        })
        
        return '<div '+ pc_css +'>' + tips_contxt + '</div>';
    }
    else{
        return '<div '+ pc_css +'>' + getHtml(id,type) + '</div>';
    }   
}

function getHtml(id,type){

    // if((env == 'dev' ||window.location.hostname.indexOf("192.") >= 0) && !store.state.userinfo.uid ){
    //     tips_contxt = `<div style="color: red; font-size: 24px; margin-bottom: 10px;">开发环境提示：请先登录，才能查看详细信息</div>`;
    //     return tips_contxt;
    // }

    let pc_css = PUBLIC.device == 'pc' && type != 'img' ? 'style="width : 300px;padding : 5px;"' : '';
    let img_css = PUBLIC.device == 'pc' ?  'auto' : '640px';
    let img_css_h = PUBLIC.device == 'pc' ?  'max-height : 780px;' : 'max-height : 95vh;';
    var temp = localStore[id] ? localStore[id].desc : '详细内容见游戏';
    var text = type != 'img' ? temp : '';
    var tips_contxt = type != 'img' ? '<div '+ pc_css +'>' + fuckTipsTxtFormat(text) + '</div>' : '<div class="img" style="font-size: 0;text-align : center;"><img src="'+ CONFIG.img_src + id + CONFIG.img_file +'" style="width:'+ img_css +';'+ img_css_h + '"></div>';

    tips_contxt = type == 'gif' ? tips_contxt + '<div class="img" style="font-size: 0;text-align : center;"><img src="'+ CONFIG.img_src + id + '.gif' +'" style="width:'+ img_css +';'+ img_css_h + '"></div>' : tips_contxt;

    // if(env == 'dev'|| window.location.hostname.indexOf("192.") >= 0){
    //     tips_contxt = tips_contxt + `<div class="dev-info" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100%; text-align: center; color: red;">开发环境提示信息  user : ${store.state.userinfo.uid || '----'}</div>`;
    // }

    return tips_contxt;   
}

function pcBindHanlder(ele , id){
    ele.onmouseenter = function(e){
        const vcTooltipDom = document.createElement('div')
        vcTooltipDom.style.cssText = `
        position:fixed;
        background: rgba(0, 0, 0, 0.8);
        color:#fff;
        box-shadow: rgba(168, 168, 168, 0.295) 1px 2px 10px;
        border: 1px solid #7c6c49;
        display:none;
        opacity : 0;
        font-size:12px;
        z-index:100;
    `
        // 设置id方便寻找
        vcTooltipDom.setAttribute('id', 'vc-tooltip')
        // 将浮层插入到body中
        document.body.appendChild(vcTooltipDom)
        // 浮层中的文字 通过属性值传递动态的显示文案
        let type = CONFIG.list.indexOf(id) > -1 ? 'img' : 'text';
        type = CONFIG.gifList.indexOf(id) > -1 ? 'gif' : type;
        if(!localStore[id]){
            getContext(id , type).then( (result) => {
                document.getElementById('vc-tooltip') ? document.getElementById('vc-tooltip').innerHTML = '<div class="tips-wrapper">' + result + '</div>' : ''; 
            } );
        }
        else{
            document.getElementById('vc-tooltip').innerHTML = '<div class="tips-wrapper">' + getHtml(id , type) + '</div>';
        }        
    }

    ele.onmousemove = function(e){
        const vcTooltipDom = document.getElementById('vc-tooltip')

        vcTooltipDom.style.display = 'block';

        let left = e.clientX + 15,
            top = e.clientY + 15;
        
        if(( e.clientX + vcTooltipDom.clientWidth ) > winW ){
            left = e.clientX - vcTooltipDom.clientWidth * 1.1 
        }

        if(( e.clientY + vcTooltipDom.clientHeight ) > winH ){
            top = e.clientY - vcTooltipDom.clientHeight * 0.5
        }
        
        vcTooltipDom.style.top = top + 'px'
        vcTooltipDom.style.left = left + 'px'
        
        vcTooltipDom.style.opacity = 1;
    }

    ele.onmouseleave = function(){
        const vcTooltipDom = document.getElementById('vc-tooltip')
        vcTooltipDom && document.body.removeChild(vcTooltipDom)  
    }
}

function mobileBindHanlder(ele , id){

    ele.onclick = function(e){
        // 创建浮层元素并设置样式
        const vcTooltipDom = document.createElement('div')
        vcTooltipDom.style.cssText = `
        overflow: hidden;
        position:fixed;
        left : 0;
        top : 0;
        background: rgba(0, 0, 0, 0.8);
        width : 100%;
        height : 100%;
        padding : 0 20px;
        box-sizing : border-box;
        color:#fff;
        display:flex;
        align-items : center;
        flex-wrap : wrap;
        font-size:24px;
        z-index:100;
    `
        // 设置id方便寻找
        vcTooltipDom.setAttribute('id', 'vc-tooltip')
        // 将浮层插入到body中
        document.getElementById('vc-tooltip') ? '' : document.body.appendChild(vcTooltipDom)
        // 浮层中的文字 通过属性值传递动态的显示文案
        //document.getElementById('vc-tooltip').innerHTML = el.getAttribute('tips')
        let type = CONFIG.list.indexOf(id) > -1 ? 'img' : 'text';
        type = CONFIG.gifList.indexOf(id) > -1 ? 'gif' : type;

        let wrapper_css = `
            width: 710px;
            color: #fff;
            z-index: 100;
            padding: 12px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            background-color: #000;
            border: 1px solid #7c6c49;        
        `;

        if(!localStore[id]){
            getContext(id,type).then( (result) => {
                document.getElementById('vc-tooltip') ? document.getElementById('vc-tooltip').innerHTML = '<div style="'+ wrapper_css +'">' + result + '</div>' : ''; 
            } );
        }
        else{
            document.getElementById('vc-tooltip').innerHTML = '<div style="'+ wrapper_css +'">' + getHtml(id,type) + '</div>'
        }

        vcTooltipDom.addEventListener('click' , (e) => {
            vcTooltipDom && document.body.removeChild(vcTooltipDom)             
        })        
    }
}

function destory(ele){
    ele.removeEventListener('click' , ele.click , false);
    ele.removeEventListener('mousemove' , ele.mousemove , false);
    ele.removeEventListener('mouseleave' , ele.mouseleave , false);
}